import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';
import BrandName from '../components/BrandName';
import api from '../services/api';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      errors: {},
      isSubmitting: false,
      submitted: false,
      error: null,
    };
  }

  handleChange = (e) => {
    this.setState({
      email: e.target.value,
      errors: {},
      error: null,
    });
  };

  validateForm = () => {
    const { email } = this.state;
    const errors = {};

    if (!email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email is invalid';
    }

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    try {
      const { email } = this.state;
      await api.post('/password-reset/request', { email });
      
      this.setState({ 
        isSubmitting: false,
        submitted: true 
      });
    } catch (error) {
      this.setState({
        isSubmitting: false,
        error: error.response?.data?.message || 'Failed to send reset email. Please try again.',
      });
    }
  };

  render() {
    const { email, errors, isSubmitting, submitted, error } = this.state;

    if (submitted) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
          <div className="w-full max-w-md">
            <div className="card animate-fade-in">
              <div className="flex justify-center mb-8">
                <img 
                  src="/logo.png" 
                  alt="PlansSource Logo" 
                  className="w-32 h-32 object-contain"
                />
              </div>

              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h1 className="text-3xl font-bold text-slate-800 mb-2">Check your email</h1>
                <p className="text-slate-600">
                  If an account exists for <strong>{email}</strong>, you will receive a password reset link shortly.
                </p>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-blue-800">
                  <strong>Didn't receive the email?</strong> Check your spam folder or try again in a few minutes.
                </p>
              </div>

              <Link 
                to="/login"
                className="block w-full text-center px-6 py-3 border border-slate-300 rounded-lg font-medium text-slate-700 hover:bg-slate-50 transition"
              >
                Back to login
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="card animate-fade-in">
            <div className="flex justify-center mb-8">
              <img 
                src="/logo.png" 
                alt="PlansSource Logo" 
                className="w-32 h-32 object-contain"
              />
            </div>

            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-slate-800 mb-2">Forgot password?</h1>
              <p className="text-slate-500">
                No worries, we'll send you reset instructions.
              </p>
            </div>

            {error && (
              <div className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <form onSubmit={this.handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2">
                  Email address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={this.handleChange}
                  className={`input-field ${errors.email ? 'border-red-500' : ''}`}
                  placeholder="you@example.com"
                  disabled={isSubmitting}
                  autoFocus
                />
                {errors.email && <p className="error-text">{errors.email}</p>}
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-primary w-full"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center">
                    <LoadingSpinner size="small" />
                    <span className="ml-2">Sending...</span>
                  </span>
                ) : (
                  'Reset password'
                )}
              </button>
            </form>

            <div className="mt-6 text-center">
              <Link 
                to="/login" 
                className="text-sm text-slate-600 hover:text-slate-900 font-medium inline-flex items-center space-x-1"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                <span>Back to login</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;